import { Directive, Input } from '@angular/core';
import { WhitelabelImage } from '../../../models';

@Directive()
export class TicketsBAndOInformationScreenBaseComponent {
  @Input() title: string;
  @Input() bAndODamageFlowDescription: string;
  @Input() navigateToButton: string;
  public whiteLabelImage = WhitelabelImage;
}
